import React, { lazy } from "react";
import { Route } from "react-router-dom";

const SmartEmail = lazy(() => import("../components/smartXpense/smartEmail"));
const SmartScan = lazy(() => import("../components/smartXpense/smartScan"));
const UberSync = lazy(() => import("../components/smartXpense/uberSync"));
const WhatsAppSync = lazy(() => import("../components/smartXpense/whatsappsync"));
const SmartForward = lazy(() => import("../components/smartXpense/smartForward"));
const SmartSms = lazy(() => import("../components/smartXpense/smartSms"));

const SmartXpenseRoutes = [
    <Route exact path="/xpendite/smartemail" component={SmartEmail} />,
    <Route exact path="/xpendite/scanx" component={SmartScan} />,
    <Route exact path="/xpendite/uber" component={UberSync} />,
    <Route exact path="/xpendite/whatsapp" component={WhatsAppSync} />,
    <Route exact path="/xpendite/smartforwards" component={SmartForward} />,
    <Route exact path="/xpendite/smartsms" component={SmartSms} />
];

export default SmartXpenseRoutes;
